import React from 'react';
import './Warning.css';

export function Warning() {
  return (
    <div>

      <div className="warning">
        <h1 className="warning-textRed"> Ops! Não encontramos o que você procura!</h1>
        <p className="warning-text">Verifique os dados corretamente e tente novamente.</p>
      </div>
    </div>

  );
}
